import React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

// Ícones do Material Symbols Outlined (Google Fonts), embutidos como SVG no bundle
// para não depender de carregamento externo da fonte.
// Fonte: https://fonts.google.com/icons (Material Symbols Outlined)

const VIEW_BOX = '0 -960 960 960';

export const SyringeIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox={VIEW_BOX}>
    <path d="M156-513q-11-12-11-28.5t11-28.5l112-112-43-43-12 12q-12 12-28.5 12T156-713q-11-11-11-28t11-28l80-80q12-12 28.5-12t28.5 12q11 11 11 28t-11 28l-12 12 43 43 112-112q12-12 28.5-12t28.5 12q12 12 12 28.5T493-793l-27 26 295 295q23 23 23 56.5T761-359l-28 29 189 188H808L676-274l-28 29q-23 23-56.5 23T535-245L240-540l-27 27q-12 11-28.5 11T156-513Zm140-83 295 295 113-114-60-61-56 56q-12 11-28.5 11.5T532-419q-12-12-12-28.5t12-28.5l56-56-60-60-56 56q-12 11-28.5 11T415-536q-11-12-11-28.5t11-28.5l56-56-61-61-114 114Zm0 0 114-114-114 114Z" />
  </SvgIcon>
);

export const PillIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox={VIEW_BOX}>
    <path d="M345-120q-94 0-159.5-65.5T120-345q0-45 17-86t49-73l270-270q32-32 73-49t86-17q94 0 159.5 65.5T840-615q0 45-17 86t-49 73L504-186q-32 32-73 49t-86 17Zm266-286 107-106q20-20 31-47t11-56q0-60-42.5-102.5T615-760q-29 0-56 11t-47 31L406-611l205 205ZM345-200q29 0 56-11t47-31l106-107-205-205-107 106q-20 20-31 47t-11 56q0 60 42.5 102.5T345-200Z" />
  </SvgIcon>
);

export const MedicationIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox={VIEW_BOX}>
    <path d="M420-260h120v-100h100v-120H540v-100H420v100H320v120h100v100ZM280-120q-33 0-56.5-23.5T200-200v-440q0-33 23.5-56.5T280-720h400q33 0 56.5 23.5T760-640v440q0 33-23.5 56.5T680-120H280Zm0-80h400v-440H280v440Zm-40-560v-80h480v80H240Zm40 120v440-440Z" />
  </SvgIcon>
);

export const WaterDropIcon: React.FC<SvgIconProps> = (props) => (
  <SvgIcon {...props} viewBox={VIEW_BOX}>
    <path d="M491-200q12-1 20.5-9.5T520-230q0-14-9-22.5t-23-7.5q-41 3-87-22.5T343-375q-2-11-10.5-18t-19.5-7q-14 0-23 10.5t-6 24.5q17 91 80 130t127 35Zm-239.5 26Q160-268 160-408q0-100 79.5-217.5T480-880q161 137 240.5 254.5T800-408q0 140-91.5 234T480-80q-137 0-228.5-94ZM652-230.5Q720-301 720-408q0-73-60.5-165T480-774Q361-665 300.5-573T240-408q0 107 68 177.5T480-160q104 0 172-70.5ZM480-480Z" />
  </SvgIcon>
);
